import { render, staticRenderFns } from "./ConnectedUsersTable.vue?vue&type=template&id=2134fcc7&"
import script from "./ConnectedUsersTable.vue?vue&type=script&lang=js&"
export * from "./ConnectedUsersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports